import React from 'react';
import styled from 'styled-components';
import ActivationCodeDisplay from 'containers/CompanyContainer/ActivationCodeDisplay';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';
import PropTypes from 'prop-types';
import { constants } from '../../constants';
import FlexRow from 'components/Primatives/FlexRow';
import PText from 'components/Primatives/PText';

const TableRow = styled(FlexRow)`
    @media (max-width: 800px){
        align-items: center;
        flex-flow: column nowrap;
    }
`

const PendingClientsTableRow = ({ email, activationCode, uid, index}) => {
    //TODO onClick to resend verification
    const marginRight = 30;
    return(
        <TableRow 
            style={{
                backgroundColor: (index  % 2 === 0) ? constants.color.grey5 : 'none',
                padding: '0 20px',
                justifyContent: 'space-between'
            }}
            wrap
        >
            <PText 
                style={{ flex: 1, marginRight: marginRight }}
                type={'value'} 
            >
                {email}
            </PText>
            
            <FlexRow 
                style={{ marginRight: marginRight }}
                type={'value'} 
            >
                <ActivationCodeDisplay code={activationCode}/>
            </FlexRow>  
            
            <FlexRow 
                style={{ marginRight: marginRight }}
                type={'value'} 
            >
                <CompanyPageButton 
                    type='dark' 
                    size='small' 
                    children='Resend verification'
                    buttonStyle={{marginLeft: 0}}
                />
            </FlexRow>
        </TableRow>
    )
}

PendingClientsTableRow.propTypes = {
    /** Client's email to be displayed */
    email: PropTypes.string,
    /** Activation code  for the client */
    activationCode: PropTypes.string,
    /** Client's uid */
    uid: PropTypes.string
}

PendingClientsTableRow.defaultProps = {
    email: '',
    activationCode: '00000000',
    uid: ''
}

export default PendingClientsTableRow;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/PendingClientsTableRow.jsx